export const FIXED_INTEREST_PERIOD_IN_YEARS = [1, 2, 3, 5, 7, 10, 15];

export const minExistingLoanNumber = 100_000;
export const maxExistingLoanNumber = 9_999_999;
export const maxBtlApplicants = 8;
export const maxBtlRealEstates = 10;
export const maximumNumber = 999999999999.99;
